import { useEffect, useState } from "react";
import { Input, Form, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { getOptionArray, selectFilterOption, modalFromLayout, getDataArray } from "@/lib/antdElementFunction";
import { yearArray, getCurrentAcademicYear } from "@/lib/dateTime";
import { getClassDataArray } from "@/lib/humanResourceManagement";
import SectionConfig from "@/config/section";
import SemesterConfig from "@/config/semester";
import { SemesterType } from "@/containers/organization/semesterManagement/types";
import { ClassType } from './types';

const { getClasses } = SectionConfig;
const { getSemestersByYear } = SemesterConfig;

type Props = {
  form: any;
  classArray: ClassType[];
}

function ModalChangeClass(props: Props) {
  const { form } = props;
  const [classDataArray, setClassDataArray] = useState<{ label: string, value: number }[]>([]);
  const [semesterArray, setSemesterArray] = useState<SemesterType[]>([]);
  const studentListT: any = getLangList("studentList");
  const semesterT: any = getLangList("semester");

  const getSemestersByYearFunction = (year: number) => {
    getSemestersByYear({ year }).then((res: any) => {
      const semesterArray = res?.value ?? [];

      setSemesterArray(semesterArray);
      setClassDataArray([]);
      form.setFieldsValue({ semesterId: null, classId: null });
    });
  };

  const getAllClassFunction = (semesterId: number) => {
    getClasses({ semesterId }).then((res: any) => {
      const allClassObject = res?.value ?? {};

      setClassDataArray(getClassDataArray(allClassObject));
      form.setFieldsValue({ classId: null });
    });
  };

  useEffect(() => {
    const { year } = form.getFieldsValue();

    getSemestersByYearFunction(year);
  }, [form]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
      initialValues={{
        year: getCurrentAcademicYear().toString(),
      }}
    >
      <Form.Item name="year" label={semesterT.YEAR} rules={[{ required: true }]}>
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
          style={{ width: '200px' }}
          onChange={(year: number) => getSemestersByYearFunction(year)}
        >
          {getOptionArray(getDataArray(yearArray, '', ''))}
        </Select>
      </Form.Item>

      <Form.Item name="semesterId" label={semesterT.SEMESTER} rules={[{ required: true }]}>
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
          style={{ width: '200px' }}
          onChange={getAllClassFunction}
        >
          {getOptionArray(getDataArray(semesterArray, 'semesterId', 'semesterName'))}
        </Select>
      </Form.Item>

      <Form.Item
        label={studentListT.CLASS}
        name="newClassId"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
        >
          {getOptionArray(classDataArray)}
        </Select>
      </Form.Item>

      <Form.Item
        label={studentListT.SEAT_NO}
        name="newSeatNum"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </Form >
  );
}

export default ModalChangeClass;